/**
 * Interface to describe the return type of the generateTraversalDebugOutput function.
 *
 * @param {string} output the string that has the element and all of its children added to it.
 * @param {number} index the ongoing index to keep track of.
 */
export interface IDebugInfo {
  output: string;
  index: number;
}

/**
 * Enum to describe the different amounts of details that will get printed to the console during debugging.
 * Basic being the least amount of details, extensive the most.
 */
export enum EDebugDetails {
  basic,
  verbose,
  detailed,
  extensive,
}

/**
 * Interface to describe the debugging level object, that is needed for the generateTraversalOutput function.
 *
 * @param {EDebugDetails} detailAmount enum that describes the amount of details that will get printed.
 * @param {boolean} matrixInfo optional boolean flag to indicate if the matrix of the elements should get printed as well. Defaults to false.
 */
export interface ISceneDebuggingLevel {
  detailAmount: EDebugDetails;
  matrixInfo?: boolean;
}
